import { openLayerFn } from "../../views/Layout";
import axios from "./Axios";
import { postZoomSessionId } from "./padoPost";

const post = axios.post;

export const postApi = async (url, formData) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  try {
    const response = await post(url, formData, config);
    const body = await JSON.parse(JSON.stringify(response.data));
    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const postApiToJson = async (url, data) => {
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };

  // const response = await post(url, data, config);
  // const body = await JSON.parse(JSON.stringify(response.data));

  // return body;

  try {
    const response = await post(url, data, config);
    const body = await JSON.parse(JSON.stringify(response.data));
    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const postSessionCheck = async (url, postZoomSessionId) => {
  try {
    //topic hsptCode-orderKey
    const response = await fetch(url + postZoomSessionId + "/users");
    // const response = await fetch(url + postZoomSessionId);
    const body = await response.json();

    return body;
  } catch (error) {
    console.log("err :: ", error);
  }
};

export const postApiHttp = async (url, email, authKey) => {
  const config = {
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  };

  try {
    const data = "email=" + email + "&authkey=" + authKey;

    const response = await post(url, data, config);
    const body = await JSON.parse(JSON.stringify(response.data));
    // const body = 'email=' + response.data.

    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const getZoomToken = async (hsptCode, orderKey) => {
  try {
    //topic hsptCode-orderKey
    const data =
      "topic=" +
      hsptCode +
      "-" +
      orderKey +
      "&role=" +
      "0" +
      "&identify=" +
      "0";

    // const response = await fetch("https://dev.mdpeople.co.kr" + ":3333/api/token/zoom?" + data);
    const response = await fetch(
      "https://stage.mdpeople.co.kr" + ":3333/api/token/zoom?" + data
    );
    const body = await response.json();

    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const postHttpImage = async (url, userToken, seqNo) => {
  const config = {
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  };

  try {
    // http://linkdoc.iptime.org/inter/interface/getImage/?userToken=3097&seqNo=1161
    const data = "userToken=" + userToken + "&seqNo=" + seqNo;

    const response = await post(url + "getImage", data, config);
    const body = await JSON.parse(JSON.stringify(response.data));

    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const postApiToNaver = async (url, params) => {
    const config = {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=euc-kr'
        }
    };

  // const response = await post(url, params, config);
  // const body = await JSON.parse(JSON.stringify(response.data));

  // return body;

  try {
    const response = await post(url, params, config);
    const body = await JSON.parse(JSON.stringify(response.data));

    return body;
  } catch (error) {
    openLayerFn($(".alert-layer-cnntFail"));
    console.log("err :: ", error);
  }
};

export const openWebSocket = () => {
  // if(phonecfg.phoneOS == "IOS") {
  //     socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
  // } else {
  //     // 임시방편
  //     socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
  //     socketManager(SocketCommand.GET_PHONE_INFO, undefined);
  // }
}

export const postApiToKakao = async (params) => {
    const config = {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=euc-kr'
            , 'Authorization': 'Bearer bf21a233622ede6107f187c680b00a21'
        }
    }

    const response = await post('https://kapi.kakao.com/v1/api/talk/friends/message/default/send', params, config);
    const body = await JSON.parse(JSON.stringify(response.data));

    return body;
}
